import { FormValidation } from "@rjsf/core";
import { forEachSchemaProperty } from "./forEachSchemaProperty";
import { IFormSchema } from "../models/IFormSchema";
import { IFormData, PickerUtils } from "..";
import _selectn from "selectn"
import _isAfter from "date-fns/isAfter"

export const validateDateFields = (formSchema: IFormSchema, formData: IFormData, errors: FormValidation): any => {

    forEachSchemaProperty(
        formSchema.schema.properties,
        formSchema.uiSchema,
        (path, property, uiSchema) => {

            if (uiSchema["ui:widget"] === "datePicker" && uiSchema["ui:maxDateNow"] === true) {
                const value = _selectn(path, formData);
                if (value) {
                    try {
                        const dateValue = PickerUtils.valueToDate(value);
                        if (!dateValue) throw Error("Invalid Date")
                        const dateAfterMaxDate = _isAfter(dateValue, new Date());
                        if (dateAfterMaxDate) {
                            errors[path].addError("Aika ei voi olla tulevaisuudessa")
                        }
                    } catch (error) {
                        //    errors[path].addError("Invalid date")
                    }
                }


            }
        }
    );

    return errors
};



/**
 *     "tapahtuma_aika": {
      "ui:widget": "datePicker",
      "ui:defaultDateNow": true,
      "ui:maxDateNow": true
    },

 */